import { useContext, useDebugValue } from "react";

import AuthContext from "../context/AuthContext";

const useAuth = () => {
  const context = useContext(AuthContext);

  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }

  const { user, persist, isLoading, setPersist, accessToken, isAuthenticated } =
    context;

  useDebugValue(user, (user) => (user ? "Logged In" : "Logged Out"));

  return {
    user,
    persist,
    isLoading,
    setPersist,
    accessToken,
    isAuthenticated,
  };
};

export default useAuth;
